import { Divider, Skeleton } from "@mui/material"
import Card from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import CardHeader from "@mui/material/CardHeader"
import { grey } from "@mui/material/colors"

const CardSkeleton = () => {
  return (
    <Card variant='outlined' sx={{ borderRadius: 2 }}>
      <CardHeader sx={{ bgcolor: grey[100] }} title={<Skeleton width='60%' />} subheader={<Skeleton width='40%' />} />

      <CardContent sx={{ p: 0 }}>
        <Skeleton height={180} variant='rectangular' />
      </CardContent>

      <Divider />

      {/* <CardActions sx={{ justifyContent: "center", p: 1.5, gap: 2 }}>
        <Skeleton variant='rectangular' width={100} height={36} />
      </CardActions> */}
    </Card>
  )
}

export default CardSkeleton
